import React, { useState, useEffect } from 'react';
import { CacheProvider } from '@emotion/react';
import rtlPlugin from "stylis-plugin-rtl";
import createCache from "@emotion/cache";
import { prefixer } from "stylis";
import Typography from '@mui/material/Typography'
import { Box } from '@mui/system';
import TextField from '@mui/material/TextField'
import Button from '@mui/material/Button'
import { Add, Check, Delete } from '@mui/icons-material';
import { IconButton, Tooltip } from '@mui/material';
import postReq from '../interface/postRequestinterface';
import {getRequest, postRequest} from '../request';
import { toast } from 'react-toastify';
import getReq from '../interface/getRequestinterface';
import jwtDecode from 'jwt-decode';
import { useNavigate } from 'react-router-dom';

const style={
    formTitle:{
      fontWeight:'bold !important'
    },
    formDescription:{
      color:'#9b9b9b'
    },
    formContainer:{
      padding: '1rem !important',
      border: '3px solid #748DA6',
      borderRadius: '10px',
      backgroundColor: '#f1f7ff59',
      height:'fit-content'
    },
    gridBox:{
      display:'grid',
      gridTemplateColumns:'45% 45%',
      columnGap:'5%',
      rowGap:'3%',
      justifyContent:'space-around',
      marginTop:'2rem',
      maxHeight:'32.5rem',
      padding:'2rem',
      overflowY:'auto',
      borderRadius: '0.5rem',
      border: '3px solid #757575'
    },
    mobileGridBox:{
      display:'grid',
      gridTemplateColumns:'90%',
      // columnGap:'5%',
      rowGap:'3%',
      justifyContent:'center',
      marginTop:'2rem'
    },
    modalStyle :{
      position: 'absolute',
      top: '50%',
      left: '50%',
      transform: 'translate(-50%, -50%)',
      p: 4,
      backgroundColor:'#fff',
      display:'flex',
      flexDirection:'column',
      borderRadius:'3px',
      width:'30rem'
    },
    modalMobileStyle:{
      position: 'absolute',
      top: '50%',
      left: '50%',
      transform: 'translate(-50%, -50%)',
      p: 4,
      backgroundColor:'#fff',
      display:'flex',
      flexDirection:'column',
      borderRadius:'3px',
      width:'15rem'
    },
    txtField:{
      width:'100%', 
    },
    headerContainer:{
      display:'flex',
      width:'100%',
      justifyContent:'space-between'
    },
    stateHandler:{
      display:'flex',
      justifyContent:'center'
    },
    stateType:{
      fontWeight:'bold'
    },
    title:{
      display:'flex',
      justifyContent:'space-between',
      width:'65rem',
    },
    pollStructure:{
        display:'flex',
        flexDirection:'column',
        // border:'3px solid #757575',
        // borderRadius:'0.3rem',
        // height:'80%',
        width:'80%',
        height:'80%',
        justifyContent:'space-around'
    }
  }
  var token:string|null = '';

function ExpertAddPoll() {
  const [pollName, setPollName] = useState<string>('');
  const [pollQuestion, setPollQuestion] = useState<Array<string>>([]);
  const [question, setQuestion] = useState<string>('');
  const [decodedToken, setDecodedToken] = useState<any>({});
  let decode:any = {};
  const navigate = useNavigate();
  const cacheRtl = createCache({
      key: "muirtl",
      stylisPlugins: [prefixer, rtlPlugin]
  });

  const handleAddQuestion=()=>{
    setPollQuestion(prevState=>[...prevState,question]);
    setQuestion('');
  }

  useEffect(() => {   
      if (token) {
        decode = jwtDecode(token);
        setDecodedToken(decode);
      }
  }, [token]);
  
  const handleRegisterPoll=async()=>{
    const q:any=[];
    for (let index = 0; index < pollQuestion.length; index++) {
      const element:any = pollQuestion[index];
      q.push(element);
    }
    const tempData={
      pollformName:pollName,
      questions:q
    }
    const {data,message,error} :postReq = await postRequest(`${process.env.REACT_APP_BASE_URL}/Poll/CreatePollForm`,tempData) as postReq;
    if(message === 'ok'){
      toast.success('با موفقیت ثبت شد!');
      navigate('/listOfQuestions');
    }else{
      toast.error(error);
    }
  }
  const handleDeleteQuestion=(index,question)=>{
    setPollQuestion((prevState)=>[...prevState.filter(x=>x !== question)]);
  }
  
  return (
    <CacheProvider value={cacheRtl}>
        <div className='background'>
            <Box className="container">
            {(decodedToken.role === 'Admin'|| decodedToken.role === 'Expert')?null:null}
                <Box sx={style.pollStructure}>
                    <Box sx={{display:'flex',flexDirection:'column',width:'100%',marginBottom:'2rem'}}>
                        <Box sx={{display:'flex',marginBottom:'0.5rem',flexDirection:'column'}}>
                            <Typography variant="h6" sx={{width:'100%',}} color="initial">نام فرم نظر سنجی را وارد کنید</Typography>
                            <TextField
                              label="نام فرم"
                              value={pollName}
                              onChange={(e)=>setPollName(e.target.value)}
                              sx={{width:'30%',marginBottom:'1rem',position:'relative',textAlign:'right'}}
                            />
                        </Box>
                        
                    {/* <Divider orientation='horizontal'/> */}
                    </Box>
                    <Box sx={style.gridBox}>
                      <Box>
                        <Typography variant="h6" >لیست سوالات:</Typography>
                        {
                          pollQuestion.map((poll,index)=>
                            <Box key={index} sx={{display:'flex',alignItems:'center',padding:'0.5rem'}}>
                              <Typography variant="body1" color="initial">
                                {index+1}:
                                {
                                  poll
                                }                             
                              </Typography>
                              <Tooltip title='حذف سوال'>
                                <IconButton aria-label="" onClick={()=>handleDeleteQuestion(index,poll)}>
                                  <Delete color='secondary'/>
                                </IconButton>
                              </Tooltip>
                            </Box>
                          )
                        }
                      </Box>
                      <Box>
                        <Box sx={{display:'flex',justifyContent:'center'}}>
                            <Typography variant="body1" sx={{width:'80%',}} color="initial">سوال نظرسنجی را وارد کنید</Typography>
                        </Box>
                        <Box sx={{display:'flex',justifyContent:'center'}}>
                            <TextField
                            value={question}
                            onChange={(e)=>setQuestion(e.target.value)}
                            multiline
                            rows={4}
                            sx={{width:'80%',}}
                            />
                        </Box>
                        <Box sx={{display:'flex',justifyContent:'center',marginTop:'0.5rem'}}>
                          <Box sx={{width:'80%',}}>
                              <Button variant="contained" color="primary" sx={{width:'fit-content'}} disabled={question.length===0} onClick={handleAddQuestion}>
                                ایجاد<Add/>
                              </Button>
                          </Box>
                        </Box>
                      </Box>
                    </Box>
                    <Box sx={{display:'flex',marginTop:'2rem'}}>
                      {/* <Box>
                          <ButtonGroup variant='contained' sx={{width:'fit-content'}} aria-label="">
                             {pollQuestion.length>1?<Button color='secondary' onClick={handleRemoveQuestion}>حذف سوال <Remove/></Button>:null} 
                          </ButtonGroup>
                      </Box> */}
                      <Button 
                        variant="contained" 
                        color="primary" 
                        sx={{width:'fit-content'}} 
                        onClick={handleRegisterPoll} 
                        // disabled={pollName.length}
                      >
                        ثبت<Check/>
                      </Button>
                    </Box>
                </Box>
            </Box>
        </div>
    </CacheProvider>
  )
}

export default ExpertAddPoll
